import { ClubV2 } from "@tudigo-monorepo/core-tudigo-api-models";
import { OrganizationDetailCard } from "@tudigo-monorepo/web-feature-organizations";

export const CircleOrganizationCardBlock = ({ club }: { club: ClubV2 }) => {
  if (!club) {
    return null;
  }

  const { organization } = club;

  if (!organization) {
    return;
  }

  return <OrganizationDetailCard organization={organization} />;
};
